import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createPharmacist } from '@/features/internal/pharmacist/apis/pharmacist'
import { PharmacistFormData } from '@/features/internal/pharmacist/types/pharmacist'
import { queryKeys } from '@/shared/hooks/queries/queryKeys'

export const useCreatePharmacistMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: PharmacistFormData) => createPharmacist(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.pharmacy.pharmacists(),
      })
    },
  })
}
